export default __webpack_public_path__ + "static/media/courseProfileFemale.d5c4a8e1.svg";